import React, { useState } from 'react';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors } from '../../../ui';
import { DropButton } from '../../../ui/DropButton';
import { Flexer, Title } from '../../dashboard/elements/LayoutElements';
import { Popover } from '../ui/Popover';
import { StatusIndicator } from './MeetingHeaderElements';
import { useActiveMeeting } from './MeetingHooks';
import { MeetingParticipantView } from './MeetingParticipantView';

const ButtonLayout = () => {
    const meeting = useActiveMeeting();
    return <Flexer flex="row" align="center" gap=".625" color={Colors.primaryText}>
        <StatusIndicator active={!!meeting && !meeting.breakStart} />
        <Title flush size="lg" weight="400">
            {meeting && !meeting.breakStart && 'Meeting In Progress'}
            {meeting && !!meeting.breakStart && 'Meeting Paused'}
        </Title>
        <Icon size="1.25" src="deqo://icons/hero/chevron-down" />
    </Flexer>;
};

export const MeetingParticipantHeaderButton = () => {

    const [open, setOpen] = useState(false);

    return <Popover
        content={<MeetingParticipantView onClose={() => setOpen(false)} />}
        inner={{
            direction: 'down',
            offset: '.5',
        }}
        open={open}
        onOpenChange={setOpen}
    >
        <DropButton data-action="editor.openMeetingMenu" active={open} rounding="full" padding=".5">
            <ButtonLayout />
        </DropButton>
    </Popover>;

};
